import Link from "next/link";
import { useRouter } from "next/router";

import { twMerge } from "tailwind-merge";

import CollectionSnippet from "components/CollectionSnippet";
import CustomCard from "components/CustomCard";
import { useApi } from "hooks/useApi";
import useMediaQuery from "hooks/useMediaQuery";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";
import { emberAppBaseUrl } from "utils/envVariables";

type CollectionPageRelatedCollectionsProps = {
  card?: boolean;
  widget?: boolean;
};

export const collectionRelatedCollectionsUrl = (slug: string) => {
  const url = new ApiEndpoint(
    `/api/v2/collections/${slug}/related-collections`
  );
  url.searchParams.append("sort", "-is-featured,featured-position,-updated-at");
  url.searchParams.append("page[size]", "6");

  return url.href;
};

const CollectionPageRelatedCollections = ({
  widget,
}: CollectionPageRelatedCollectionsProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { mobile } = useMediaQuery();

  const { data } = useApi(collectionRelatedCollectionsUrl(slug), baseFetcher);

  if (!data?.data?.length) return <></>;

  const content = (
    <div>
      <div
        className={twMerge(
          "px-[15px]",
          "py-[10px]",
          "font-medium",
          "text-[16px]",
          "text-[#1f1f20]"
        )}
      >
        Related Collections
      </div>
      <div className="overflow-y-auto h-[230px]">
        {data?.data?.map?.((collection: any) => (
          <CollectionSnippet
            key={collection.id}
            collection={collection}
            compact
          />
        ))}
      </div>
      <div className="p-[15px]">
        {mobile ? (
          <a
            href={`${emberAppBaseUrl}/collections`}
            className={twMerge("text-[14px]", "font-medium", "text-smart-teal")}
          >
            View all Collections »
          </a>
        ) : (
          <Link
            href="/collections"
            className={twMerge("text-[14px]", "font-medium", "text-smart-teal")}
          >
            View all Collections »
          </Link>
        )}
      </div>
    </div>
  );

  if (widget) {
    return <CustomCard className="p-0">{content}</CustomCard>;
  }

  return content;
};

export default CollectionPageRelatedCollections;
